import { UnitSystem } from '@/interfaces/units';
import { BaseScenarioType } from '@/lib/types/IBaseScenario';
import { DesignScenarioType, EsalCalculationMethods } from '@/modules/design/interfaces/shared';
import { IProjectMetadata } from '@/interfaces/report';
import {
  IAcOverlayDesignImperial,
  IAcOverlayLayerImperial,
  StructuralEvaluationMethods,
} from '@/modules/design/interfaces/acOverlay';
import {userStore} from "@/store/store";

export const createNewAcOverlayScenario = function (project: IProjectMetadata): IAcOverlayDesignImperial {
  return {
    id: null,
    user: userStore.user ? userStore.user.id : null,
    project: project.id,
    created: new Date(Date.now()).toISOString(),
    modified: new Date(Date.now()).toISOString(),
    visible: true,
    displayUnits: project.displayUnits,
    unitSystem: UnitSystem.Imperial,
    scenarioType: BaseScenarioType.design,
    designScenarioType: DesignScenarioType.acOverlay,
    isComputedFromLegacy: false,

    name: 'New AC Overlay Pavement Design',
    description: null,
    state: project.state,

    completionYear: null,
    roadwayClassification: null,


    // Pavement Design
    pavementType: null,

    // Layers
    subgradeSoilType: null,
    subgradeRValue: null,
    subgradeCbr: null,
    existingLayerCoeff: 0.44,
    modulusCalculationMethod: null,

    // Structural Eval
    structuralEvaluationMethod: StructuralEvaluationMethods.testing,

    // Condition Survey
    coresTaken: null,
    crackCoresTaken: null,
    topDownCracking: null,
    stripping: null,

    alligatorLow: '0',
    alligatorMed: '0',
    alligatorHigh: '0',

    transverseLow: '0',
    transverseMed: '0',
    transverseHigh: '0',

    millRemoveDistressed: false,

    // Nondestructive testing
    combinedLayerStiffness: null,
    estimatedStructuralCoefficient: null,


    // Design Parameters
    designPeriod_years: null, // Years
    reliabilityLevel: null,
    standardError: 0.5,
    initialServiceability: null,
    terminalServiceability: null,
    deltaServiceability: null,

    // Traffic and Loading
    esalCalculatedFrom: EsalCalculationMethods.design,
    // From AADT
    initialTraffic: null,
    trafficGrowthRate: 0,
    esalGrowthRate: 0,

    // From ESALs
    esals: null,
    loadEquivalencyFactor: null,

    // From Design ESALs
    totalDesignEsals: null,

    // Pavement Layers
    existingLayers: [],

    subgradeModulus_psi: null,
    overlayLayerMinimumThickness_in: 1,

    // Condition Survey
    crackDepth_in: null,
    distressDepth_in: null,
    removeDepth_in: null,

    // Nondestructive testing
    designSubgradeModulus_psi: null,

  };
};
